import type {
    Message,
    MessageState,
    Model,
    PMChatsState,
} from '../../../../types/mfc'
import { idToSlug } from '../../../state/state.users'
import i18n from '../../../utilities/i18n'

export const broadcastStateText = ({
    isTruePrivate,
    isBroadcasting,
    isPrivateShow,
    isGroupShow,
    isClubShow,
    isOffline,
    isLounge,
    isAway,
}: Partial<Model>) => {
    if (isLounge) return ''
    if (isTruePrivate) return i18n.t('userStatus.isInTruePrivateShow')
    if (isPrivateShow) return i18n.t('userStatus.isInPrivateShow')
    if (isGroupShow) return i18n.t('userStatus.isInGroupShow')
    if (isClubShow) return i18n.t('userStatus.isInClubShow')
    if (isAway) return i18n.t('userStatus.isAway')
    if (isOffline) return i18n.t('userStatus.isOffline')
    if (isBroadcasting) return i18n.t('userStatus.isBroadcasting')
}

export type IMessage = MessageState & {
    list: Array<Message>
    timestamp: number
}

export const messageUtil = (() => {
    const cache: {
        messages: IMessage[]
        messageSlugs: string[]
        unreadMessages: Record<string, number>
    } = {
        messages: [],
        messageSlugs: [],
        unreadMessages: {},
    }
    const updateMessageSlugs = (messages: IMessage[]) => {
        if (!Array.isArray(messages)) return
        cache.messageSlugs = messages.map(({ slug }) => slug)
    }
    const updateUnreadMessages = (messages: IMessage[]) => {
        if (!Array.isArray(messages)) return
        cache.unreadMessages = {}
        messages.forEach(
            ({ slug, unread }) => (cache.unreadMessages[slug] = unread),
        )
    }
    const processMessages = (chats: PMChatsState) => {
        if (!chats) return
        cache.messages = Object.entries(chats).map(([id, data]) => {
            const { messages: list = [], unread } = data
            const messageCount = list.length

            if (messageCount > 0 && !list[messageCount - 1]) {
                console.error(
                    '[processMessages] This is not suppose to happen!',
                    JSON.stringify(data, null, 4),
                )
                return null
            }

            const msgs: IMessage = {
                timestamp:
                    messageCount > 0 ? list[messageCount - 1]?.timestamp : null,
                slug: idToSlug[id],
                unread,
                list,
            }
            return msgs
        })
        updateMessageSlugs(cache.messages)
        updateUnreadMessages(cache.messages)
    }
    return { cache, processMessages }
})()
